// Convert a <input type="datetime-local"> value (local time, no TZ)
// to a UTC ISO string for storage.
export const localInputToIso = (localValue) => {
  if (!localValue) return null;
  // localValue is "YYYY-MM-DDTHH:mm"
  const d = new Date(localValue);
  if (isNaN(d.getTime())) return null;
  return d.toISOString();
};

// Convert a UTC ISO string to a value suitable for datetime-local input
export const isoToLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatPretty = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const nowIso = () => new Date().toISOString();
